/**
 * EN translations
 * Auto-generated by scripts/regenerate-locale-indexes.js
 * DO NOT EDIT THIS FILE MANUALLY
 */

import accounting from "./accounting.json";
import agentLogs from "./agentLogs.json";
import ai from "./ai.json";
import aiImport from "./aiImport.json";
import aiMonitoring from "./aiMonitoring.json";
import aiProposals from "./aiProposals.json";
import aiTransparency from "./aiTransparency.json";
import aiWorkflows from "./aiWorkflows.json";
import audioOrders from "./audioOrders.json";
import auth from "./auth.json";
import billing from "./billing.json";
import businessIntelligence from "./businessIntelligence.json";
import charts from "./charts.json";
import chat from "./chat.json";
import clientGroups from "./clientGroups.json";
import common from "./common.json";
import company from "./company.json";
import companyAiMonitoring from "./companyAiMonitoring.json";
import contacts from "./contacts.json";
import crm from "./crm.json";
import dailyRecap from "./dailyRecap.json";
import dialog from "./dialog.json";
import dictionary from "./dictionary.json";
import directSale from "./directSale.json";
import documents from "./documents.json";
import emails from "./emails.json";
import errors from "./errors.json";
import exportData from "./export.json";
import feedback from "./feedback.json";
import flows from "./flows.json";
import form from "./form.json";
import groups from "./groups.json";
import guide from "./guide.json";
import home from "./home.json";
import inventory from "./inventory.json";
import language from "./language.json";
import locations from "./locations.json";
import lots from "./lots.json";
import messageSettings from "./messageSettings.json";
import metadata from "./metadata.json";
import mobileChat from "./mobileChat.json";
import mobileNav from "./mobileNav.json";
import mobileProposals from "./mobileProposals.json";
import monitoring from "./monitoring.json";
import navigation from "./navigation.json";
import offers from "./offers.json";
import operations from "./operations.json";
import orderStatus from "./orderStatus.json";
import orders from "./orders.json";
import ordersRecap from "./ordersRecap.json";
import parameters from "./parameters.json";
import partnerImport from "./partnerImport.json";
import partnerSelect from "./partnerSelect.json";
import partners from "./partners.json";
import permissions from "./permissions.json";
import phone from "./phone.json";
import preOrder from "./preOrder.json";
import preOrderStatus from "./preOrderStatus.json";
import preferences from "./preferences.json";
import presence from "./presence.json";
import priceUpdate from "./priceUpdate.json";
import pricing from "./pricing.json";
import productCodes from "./productCodes.json";
import products from "./products.json";
import profile from "./profile.json";
import profilePhoto from "./profilePhoto.json";
import purchases from "./purchases.json";
import recap from "./recap.json";
import recording from "./recording.json";
import reports from "./reports.json";
import ressere from "./ressere.json";
import routes from "./routes.json";
import sage from "./sage.json";
import savedOffers from "./savedOffers.json";
import seeding from "./seeding.json";
import select from "./select.json";
import sheet from "./sheet.json";
import sidebar from "./sidebar.json";
import signup from "./signup.json";
import status from "./status.json";
import stocks from "./stocks.json";
import traceability from "./traceability.json";
import ui from "./ui.json";
import unanswered from "./unanswered.json";
import unifiedRecap from "./unifiedRecap.json";
import units from "./units.json";
import whatsapp from "./whatsapp.json";
import workflows from "./workflows.json";

const translations = {
  accounting: accounting,
  agentLogs: agentLogs,
  ai: ai,
  aiImport: aiImport,
  aiMonitoring: aiMonitoring,
  aiProposals: aiProposals,
  aiTransparency: aiTransparency,
  aiWorkflows: aiWorkflows,
  audioOrders: audioOrders,
  auth: auth,
  billing: billing,
  businessIntelligence: businessIntelligence,
  charts: charts,
  chat: chat,
  clientGroups: clientGroups,
  common: common,
  company: company,
  companyAiMonitoring: companyAiMonitoring,
  contacts: contacts,
  crm: crm,
  dailyRecap: dailyRecap,
  dialog: dialog,
  dictionary: dictionary,
  directSale: directSale,
  documents: documents,
  emails: emails,
  errors: errors,
  export: exportData,
  feedback: feedback,
  flows: flows,
  form: form,
  groups: groups,
  guide: guide,
  home: home,
  inventory: inventory,
  language: language,
  locations: locations,
  lots: lots,
  messageSettings: messageSettings,
  metadata: metadata,
  mobileChat: mobileChat,
  mobileNav: mobileNav,
  mobileProposals: mobileProposals,
  monitoring: monitoring,
  navigation: navigation,
  offers: offers,
  operations: operations,
  orderStatus: orderStatus,
  orders: orders,
  ordersRecap: ordersRecap,
  parameters: parameters,
  partnerImport: partnerImport,
  partnerSelect: partnerSelect,
  partners: partners,
  permissions: permissions,
  phone: phone,
  preOrder: preOrder,
  preOrderStatus: preOrderStatus,
  preferences: preferences,
  presence: presence,
  priceUpdate: priceUpdate,
  pricing: pricing,
  productCodes: productCodes,
  products: products,
  profile: profile,
  profilePhoto: profilePhoto,
  purchases: purchases,
  recap: recap,
  recording: recording,
  reports: reports,
  ressere: ressere,
  routes: routes,
  sage: sage,
  savedOffers: savedOffers,
  seeding: seeding,
  select: select,
  sheet: sheet,
  sidebar: sidebar,
  signup: signup,
  status: status,
  stocks: stocks,
  traceability: traceability,
  ui: ui,
  unanswered: unanswered,
  unifiedRecap: unifiedRecap,
  units: units,
  whatsapp: whatsapp,
  workflows: workflows,
};

export default translations;
